import { render, staticRenderFns } from "./default-ar.vue?vue&type=template&id=2970e6a0"
import script from "./default-ar.vue?vue&type=script&lang=js"
export * from "./default-ar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterContent: require('/vercel/path0/components/FooterContent.vue').default})
